module.exports = __webpack_public_path__ + "static/media/FOIRE.2ae9df46.png";